// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields} = state;

	let isCompany = !Validator.validateSsn(fields.customer_social_security_number, true) &&
		Validator.validateOrgNum(fields.customer_social_security_number, true);

	if (isCompany) {

		/**
		 * Start by making sure that at least one signatory has been selected an that the email is valid
		 */
		let hasAtLeastOneSignatory = false;
		let isSignatoryEmailValid = true;
		let allRepFieldsValid = true;

		fields.reps.forEach(function (rep) {
			if (rep.role.includes("signatory")) {
				hasAtLeastOneSignatory = true;
				isSignatoryEmailValid = Validator.validateEmail(rep.email);
			}

			if (rep.first_name.trim().length === 0 ||
				rep.last_name.trim().length === 0) {
				allRepFieldsValid = false;
			}
		});

		if (!hasAtLeastOneSignatory || !isSignatoryEmailValid || !allRepFieldsValid) {
			return false;
		}

		/**
		 * Check other company fields
		 */
		return !!(
			fields.customer_firstname.length > 0
			&& Validator.validateOrgNum(fields.customer_social_security_number, true)
			&& fields.customer_address_street.length > 0
			&& fields.customer_address_zipcode.length > 0
			&& fields.customer_address_city.length > 0
		);
	}

	return !!(
		fields.customer_firstname.length > 0
		&& fields.customer_lastname.length > 0
		&& Validator.validateSsn(fields.customer_social_security_number, true)
		&& fields.customer_address_street.length > 0
		&& fields.customer_address_zipcode.length > 0
		&& fields.customer_address_city.length > 0
		&& Validator.validateEmail(fields.customer_email)
	);
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/CustomerInformation/no-prefetch/CustomerInformation.fulfillment.js